var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlphaSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 0v10.322L8.073 8 9.5 9.427l-4.75 4.75L0 9.427 1.427 8l2.323 2.322V0h2zM18 8v2h-4V8h4zm3-4v2h-7V4h7zm3-4v2H14V0h10z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxNSI+CiAgPHBhdGggZD0iTTUuNzUgMHYxMC4zMjJMOC4wNzMgOCA5LjUgOS40MjdsLTQuNzUgNC43NUwwIDkuNDI3IDEuNDI3IDhsMi4zMjMgMi4zMjJWMGgyek0xOCA4djJoLTRWOGg0em0zLTR2MmgtN1Y0aDd6bTMtNHYySDE0VjBoMTB6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+";
export { SvgAlphaSort as ReactComponent };